module.exports = "/_next/static/images/CentralizeAndSimplify-60f910ca99d7a18ae8f8271c1b6560d6.webp";